export default __webpack_public_path__ + "static/media/TrendTwo.632e437a.svg";